import React from 'react';
import { useLanguage } from './LanguageContext';
interface Props {
  isVisible: boolean;
  onContinue: () => void;
  onSkipConfirm: () => void;
  onDismiss: () => void;
}
export function SkipNudgeSheet({
  isVisible,
  onContinue,
  onSkipConfirm,
  onDismiss
}: Props) {
  const {
    t
  } = useLanguage();
  if (!isVisible) return null;
  return <div className="absolute inset-0 z-[100] flex flex-col justify-end" data-id="element-359">
      {/* Backdrop */}
      <div className="absolute inset-0 bg-[#0D0D0D]/60 transition-opacity duration-300" onClick={onDismiss} data-id="element-360" />

      {/* Bottom Sheet */}
      <div className="relative bg-[#1A1A1A] rounded-t-2xl px-6 pt-6 w-full max-h-[80vh] overflow-y-auto flex flex-col animate-in slide-in-from-bottom duration-300 ease-out" style={{
      paddingBottom: 'calc(env(safe-area-inset-bottom) + 32px)'
    }} data-id="element-361">
        {/* Handle */}
        <div className="w-10 h-1 bg-[#2A2A2A] rounded-full mx-auto mb-2" data-id="element-362" />

        <h2 className="text-white text-[16px] font-semibold mt-4" data-id="element-363">
          {t('nudge.heading')}
        </h2>

        <p className="text-[#AAAAAA] text-[14px] mt-2 leading-relaxed" data-id="element-364">
          {t('nudge.body')}
        </p>

        <div className="mt-6 flex flex-col gap-3" data-id="element-365">
          <button onClick={onContinue} className="w-full py-4 rounded-full bg-[#C5D82D] text-[#0D0D0D] text-[14px] font-semibold tracking-wide transition-colors hover:bg-[#d4e63a]" data-id="element-366">
            {t('nudge.continue')}
          </button>

          <button onClick={onSkipConfirm} className="w-full py-3 text-[#888888] text-[14px] font-medium transition-colors hover:text-white" data-id="element-367">
            {t('nudge.later')}
          </button>
        </div>
      </div>
    </div>;
}